<template>
  <div>
    <CoronaInfo v-if="false"></CoronaInfo>

    <Search />

    <router-view></router-view>
  </div>
</template>

<script>
import Search from "@/components/Search";
import CoronaInfo from "@/components/CoronaInfo";

export default {
  name: "Offers",
  components: { CoronaInfo, Search }
};
</script>

<style scoped>
.offer {
  margin: 5px 10px;
  border-radius: 5px;
  box-shadow: 0 0 5px -1px rgba(0, 0, 0, 1);
  -webkit-box-shadow: 0 0 5px -1px rgba(0, 0, 0, 1);
  -moz-box-shadow: 0 0 5px -1px rgba(0, 0, 0, 1);
  padding: 20px;
}
.offer-null {
  width: 100%;
  text-align: center;
}
.header span {
  color: red;
}
.location {
  margin: 10px 0px;
  color: gray;
}
.offer-footer {
  margin-bottom: 20px;
  width: 100%;
}
.offer-footer .date {
  float: left;
}
.offer-footer .price {
  float: right;
}
.spinner {
  border: 6px solid #f3f3f3;
  border-top: 6px solid gray;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 2s linear infinite;
  text-align: center;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
